import gql from "graphql-tag";

export default gql`query FilesByCompletionDate($date:Date!) {
    filesByCompletionDate(date:$date) {
        id    
        referencelong
        bundleCompletionReceived
        category{
            id
            shortname
        }
        department {
            id
            name
        }
        addressBooksByType(types:[3,4]) {
            id
            entity {
                id
                name
                type {
                    id
                }
            }
        }
        subjectProperty
        bundleCompletion{
            id
        }
      }
  }`